// reapply-enabled-tools-after-sync.ts
//
// Sau khi sync merge lại settings.json.tpl (có thể đổi/ghi đè settings), re-apply
// mọi tool đang enabled=true để hook tool KHÔNG bị mất. Không có bước này,
// tool "biến mất" sau mỗi `avatar sync`.
//
// Idempotent: enable lại không nhân đôi entry (dedupe trong enableTool lo).
// Fail-mềm: tool trong state nhưng pack đã bỏ manifest → enableToolByName
// trả false (warn), không crash sync.

import { log } from "./terminal-logger.js";
import { enableToolByName } from "./tool-enable-disable-orchestrator.js";
import { listEnabledTools } from "./tool-state-store.js";

export async function reapplyEnabledToolsAfterSync(workspacePath: string): Promise<void> {
  const enabled = await listEnabledTools(workspacePath);
  if (enabled.length === 0) {
    return;
  }
  log.info(`Re-apply ${enabled.length} tool(s) đang bật vào settings.json...`);
  for (const name of enabled) {
    await enableToolByName(workspacePath, name);
  }
}
